import Localization from "./lib/localization/core";

// @ts-ignore
/*window.axios = (axios)*/
// @ts-ignore

Localization.init()
